import { Dispatch, SetStateAction, useCallback, useState } from 'react';

import useRouterQueryState from './useRouterQueryState';

export type DefaultItemResolver<T> = (data: T[]) => T | undefined;

function usePersistentState<T extends { id: string }>(
  items: T[],
  key: string,
  defaultItem: DefaultItemResolver<T> = data => (data.length === 0 ? undefined : data[0]),
): [T, Dispatch<SetStateAction<T>>] {
  const [id, setId] = useRouterQueryState<string>(key, defaultItem(items)?.id);
  const [_item, _setItem] = useState<T>(defaultItem(items));

  const setItem = useCallback(
    (item: T) => {
      _setItem(item);
      setId(item.id);
    },
    [setId],
  );

  return [items.find(i => i.id === id) ?? undefined, setItem];
}

export default usePersistentState;
